import {
  MILLISECONDS_PER_SECOND,
  SECONDS_PER_MINUTE,
} from "@/constants/time.constants";
import { ENVIRONMENT_CONSTANTS } from "./environment.constants";

/** Refresh one minute before the token's 60-minute lifetime. */
const TOKEN_REFRESH_LEAD_MINUTES = 59;

export enum COOKIE_KEYS {
  AC_TOKEN = "ac-auth.id-token",
  AC_REFRESH_TOKEN = "ac-auth.refresh-token",
  IS_CONNECTED_AS = "is_connected_as",
  IMPERSONATE_TOKEN = "impersonate_token",
  AUTH_STRATEGY = "auth_strategy",
}

export const COOKIE_DOMAINS: Record<ENVIRONMENT_CONSTANTS, string> = {
  [ENVIRONMENT_CONSTANTS.DEVELOPMENT]: ".aircall-staging.com",
  [ENVIRONMENT_CONSTANTS.TEST]: ".aircall-staging.com",
  [ENVIRONMENT_CONSTANTS.STAGING]: ".aircall-staging.com",
  [ENVIRONMENT_CONSTANTS.PRODUCTION]: ".aircall.io",
};

export const REFRESH_TOKEN_INTERVAL =
  TOKEN_REFRESH_LEAD_MINUTES * SECONDS_PER_MINUTE * MILLISECONDS_PER_SECOND;
